import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
// import downloadIcon from "../../../assets/download.svg";
import { NotificationManager } from "react-notifications";
import { useDispatch } from "react-redux";

export const FileDropzone = ({files, setFiles}) => {
  const dispatch = useDispatch();

  const acceptedFilesExtension = ["text/csv", "application/vnd.ms-excel"];

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFilesExtension.includes(acceptedFiles[0].type)) {
      setFiles(acceptedFiles);
    } else {
      NotificationManager.error(`${acceptedFiles[0].type} no aceptado`);
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  const renderFiles = () => {
    return files.map((csv) => {
      return <>{csv.name}</>;
    });
  };

  return (
    <div
      style={{
        borderRadius: "24px",
        height: "361px",
        backgroundColor: "#EDEDED",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="h-100" style={{ cursor: "pointer" }} {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="h-100 d-flex align-items-center justify-content-center">
          <div style={{ textAlign: "center" }}>
            {/* <img src={downloadIcon} alt={"Subir fichero"} /> */}
            <div
              className="mt-20"
              style={{ fontSize: "24px", fontWeight: "600", color: "#145388" }}
            >
              {files ? (
                <>{renderFiles()}</>
              ) : (
                "Selecciona un fichero o arrástralo aquí"
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
